export const iconStyle = {
    border: '2px solid rgb(30, 30, 30)',
    borderRadius: '50%',
    width: '13%',
}

export const subredditSectionStyle = {
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
    padding: 20, 
    backgroundColor: '#fff',
    height: '100%'
}